import React from 'react';
import styles from './BaseSimpleItemEditorFooter.module.css';
import {Divider} from "@mui/material";
import BaseSimpleItemEditorFooterButton from "./BaseSimpleItemEditorFooterButton";

const BaseSimpleItemEditorFooter = ({isAddSubMode, onAddBtnClick, onClearBtnClick, onSaveBtnClick, onDeleteBtnClick,
                                          readOnlyMode = false}) => {
    return (
        <div className={styles.main}>
            <Divider component="div"/>
            <div className={styles.buttonsArea}>
                {isAddSubMode && <BaseSimpleItemEditorFooterButton
                    label="Добавить"
                    onClick={onAddBtnClick}
                />}
                {isAddSubMode && <BaseSimpleItemEditorFooterButton
                    label="Очистить"
                    onClick={onClearBtnClick}
                />}
                {!isAddSubMode && <BaseSimpleItemEditorFooterButton
                    label="Сохранить"
                    onClick={onSaveBtnClick}
                    disabled={readOnlyMode}
                />}
                {!isAddSubMode && <BaseSimpleItemEditorFooterButton
                    label="Удалить"
                    /*onClick={onDeleteBtnClick}*/
                    disabled
                />}
            </div>
        </div>
    );
};

export default BaseSimpleItemEditorFooter;